export default __webpack_public_path__ + "static/media/picture_Pro_APP.78b09b78.png";